(() => {
  'use strict';
  const dialog = document.getElementById('localization-dialog');
  if (!dialog || !dialog.showModal) return;
  const form = document.getElementById('MyMaskLocalization');
  const language = form.elements.language_code;
  const country = form.elements.country_code;
  const key = 'mymask.localization.v1';
  let opener;
  let remembered;
  try { remembered = localStorage.getItem(key); } catch (_) { /* Storage can be disabled. */ }
  const remember = () => { try { localStorage.setItem(key, JSON.stringify({ language: language.value, country: country.value })); } catch (_) {} };
  const close = () => { dialog.close(); remember(); if (opener) opener.focus(); };
  const open = () => { if (!dialog.open) dialog.showModal(); };
  document.querySelectorAll('[data-open-localization]').forEach(button => button.addEventListener('click', () => { opener = button; open(); }));
  dialog.querySelector('[data-close-localization]').addEventListener('click', close);
  dialog.addEventListener('cancel', () => { remember(); });
  country.addEventListener('change', () => { dialog.querySelector('[data-locale-currency]').textContent = country.selectedOptions[0].dataset.currency; });
  form.addEventListener('submit', () => {
    // Shopify handles locale, market, currency and its localization cookie together.
    form.elements.return_to.value = location.pathname + location.search + location.hash;
    remember();
  });
  if (!remembered && !window.Shopify?.designMode) {
    const supported = [...language.options].map(option => option.value);
    const preferences = (navigator.languages || [navigator.language]).map(value => value.replace(/^no(?=-|$)/i, 'nb'));
    const suggested = preferences.map(value => value.toLowerCase()).map(value => supported.find(code => code.toLowerCase() === value) || supported.find(code => code.toLowerCase() === value.split('-')[0])).find(Boolean);
    // Explicit localized links take priority over browser preferences.
    const explicitLocale = supported.some(code => code !== 'en' && (location.pathname === '/' + code || location.pathname.startsWith('/' + code + '/')));
    if (suggested && !explicitLocale) language.value = suggested;
    if (suggested && !explicitLocale && suggested !== window.MyMask.locale) dialog.querySelector('[data-locale-recommendation]').hidden = false;
    // A region remains the Shopify-determined market. A browser's language is not a delivery address.
    open();
  }
})();
